import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
// import NotificationsIcon from "@material-ui/icons/Notifications";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { ContextGlobal } from "../../context";
import { NavLink } from "react-router-dom";
import Popover from "@material-ui/core/Popover";

const lightColor = "rgba(255, 255, 255, 0.7)";

const styles = (theme) => ({
  secondaryBar: {
    zIndex: 0,
  },
  menuButton: {
    marginLeft: -theme.spacing(1),
  },
  iconButtonAvatar: {
    padding: 4,
  },
  link: {
    textDecoration: "none",
    color: lightColor,
    "&:hover": {
      color: theme.palette.common.white,
    },
  },
  button: {
    borderColor: lightColor,
  },
  Navselected: {
    opacity: "1 !important",
    borderBottom: "2px solid",
  },
  NavTab: {
    opacity: "0.7",
  },
  typography: {
    padding: "16px 30px",
    display: "flex",
    flexDirection: "column",
    placeItems: "center",
  },
  logout: {
    margin: "10px 0px",
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
    color: "white",
  },
});

function Header(props) {
  const { data } = useContext(ContextGlobal);
  const { classes, onDrawerToggle } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <React.Fragment>
      <AppBar color="primary" position="sticky" elevation={0}>
        <Toolbar style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          <Grid container spacing={1} alignItems="center">
            <Hidden smUp>
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={onDrawerToggle}
                  className={classes.menuButton}
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            </Hidden>
            <Grid item xs>
              <Typography color="inherit" variant="h5" component="h1">
                {props.HeaderData.heading}
              </Typography>
            </Grid>

            <Grid item xs />

            {/* Notification */}
            {/* <Grid item>
              <Tooltip title="Alerts • No alerts">
                <IconButton color="inherit">
                  <NotificationsIcon />
                </IconButton>
              </Tooltip>
            </Grid> */}

            {/* User icon */}
            <Grid item>
              <IconButton
                aria-describedby={id}
                color="inherit"
                className={classes.iconButtonAvatar}
                onClick={handleClick}
              >
                <Avatar
                  src="/static/images/avatar/1.jpg"
                  alt={data.data.name}
                />
              </IconButton>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <AppBar
        component="div"
        className={classes.secondaryBar}
        color="primary"
        position="static"
        elevation={0}
      >
        <Tabs textColor="inherit">
          {props.HeaderData.tabs.map((x) => (
            <NavLink
              to={x.path}
              activeClassName={classes.Navselected}
              className={classes.NavTab}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              <Tab
                style={{ opacity: "inherit" }}
                textColor="inherit"
                label={x.id}
              />
            </NavLink>
          ))}

          {/* <Tab textColor="inherit" label="Users" />
          <Tab textColor="inherit" label="Sign-in method" />
          <Tab textColor="inherit" label="Templates" />
          <Tab textColor="inherit" label="Usage" /> */}
        </Tabs>
      </AppBar>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Typography className={classes.typography}>
          <p style={{ margin: "0" }}>{data.data.name}</p>
          <p style={{ color: "#6d6b6b", margin: "0" }}>{data.data.contact}</p>
          <Button
            className={classes.logout}
            color="primary"
            variant="contained"
            onClick={props.logout}
          >
            Logout
          </Button>
        </Typography>
      </Popover>
    </React.Fragment>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  onDrawerToggle: PropTypes.func.isRequired,
};

export default withStyles(styles)(Header);
